export default __webpack_public_path__ + "static/bunnynet-dark-d6a41260b1e4b665cb2dc413e3eb84ca.svg";